import React from "react";
import redBgRectangle from "../assets/rectangle.png";
import redBgRectangle2 from "../assets/rectangle2.png";
import buyMoreWinMore from "../assets/buymorewinmore.png";
import rightArrow from "../assets/right-arrow.png";
import { Link } from "react-router-dom";

const DashboardHeroe: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row gap-6">
      <div
        className="w-full h-fit md:w-[700px] md:h-[400px] flex flex-col md:flex-row items-center p-4  gap-4 db-heroe-col rounded-md md:rounded-0"
        style={{
          backgroundImage: `url(${redBgRectangle})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          // backgroundSize: "contain",
        }}
      >
        <img
          src={buyMoreWinMore}
          className="w-full md:w-[200px]"
          alt="Buy More Win More"
        />

        <h1 className="text-white font-bold text-4xl md:text-[40px] md:text-center leading-normal md:leading-[45px]">
          Indomie Pack of Fortune Promo Analytics
        </h1>

        <Link
          to={"/explore"}
          className="px-4 py-4 md:py-3 bg-[#DC0315] text-center text-white rounded-xl md:mt-[190px] min-w-full md:min-w-[130px]"
        >
          Explore More
        </Link>
      </div>

      <div
        className="w-full h-fit flex flex-col md:flex-row md:w-[290px] md:h-[400px] px-4 gap-x-4 db-heroe-col rounded-md md:rounded-0"
        style={{
          backgroundImage: `url(${redBgRectangle2})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          // backgroundSize: "contain",
        }}
      >
        <div className="self-center mt-[120px] bg-white bg-opacity-40 p-3 rounded-2xl text-white">
          <h5 className="font-semibold text-md">Daily Promo Insights</h5>

          <p className="text-sm">
            Optimize campaigns with daily insights, and interactive metrics
          </p>
        </div>

        <div className="self-end md:self-center mt-10 md:mt-[210px] flex justify-center w-[80px] mr-[-24px]  md:mr-[-15px]">
          <Link
            to={"/explore"}
            className="bg-[#DC0315] p-3 text-center h-fit text-white rounded-full"
          >
            <img src={rightArrow} width={25} height={25} alt="Go" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeroe;
